import { REDUCER_NAME } from './const'
import { createTableSettingSelector } from '../../form/state/table-state-helper'
import { createTableSelector } from '../../table/state/selector'
import { TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT } from './type'

export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}

export const selectTaskListWithAttachment = (state) => {
    return selectOwnState(state).taskListWithAttachment
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectTable = createTableSelector(selectOwnState, TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const selectTableSetting = createTableSettingSelector(selectOwnState)

export const selectAllOpenTaskWithAttachmentTableSetting = createTableSettingSelector(selectOwnState, 'allOpenTaskWithAttachmentTableSetting')



// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/state/selector.js